// extracted by mini-css-extract-plugin
export default {"opportunitylist_wrapper":"opportunities_opportunitylist_wrapper__YPYDX","opportunitylist_heading":"opportunities_opportunitylist_heading__vhXmX"};